const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'brochure_standard',
    },
  },
  copywriting: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "brochure_standard"',
      mapTo: [ 'copywriting' ],
    },
  },
  numberOfLanguages: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "brochure_standard"',
      mapTo: [ 'numberOfLanguages' ],
    },
  },
  numberOfPages: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "brochure_standard"',
      mapTo: [ 'numberOfPages' ],
    },
  },
};


const dependencies = {
  hard: [],
  soft: [],
};


export default { specs, dependencies };
